import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";

const LoadingComponent = () => {
  return (
    <Box sx={{ width: "100%", zIndex: "99999", position: "relative" }}>
      <LinearProgress />
    </Box>
  );
};

export default LoadingComponent;
